import type { StatsWorkbookRows, WorkbookRow } from "../domain/statsWorkbook";

export interface WorkbookLibrary {
  utils: {
    book_new(): unknown;
    json_to_sheet(rows: WorkbookRow[]): unknown;
    book_append_sheet(
      workbook: unknown,
      worksheet: unknown,
      name: string,
    ): void;
  };
  writeFile(workbook: unknown, filename: string): void;
}

export async function loadWorkbookLibrary(): Promise<WorkbookLibrary> {
  const xlsx = await import("xlsx");
  return {
    utils: {
      book_new: () => xlsx.utils.book_new(),
      json_to_sheet: (rows) => xlsx.utils.json_to_sheet(rows),
      book_append_sheet: (workbook, worksheet, name) =>
        xlsx.utils.book_append_sheet(
          workbook as import("xlsx").WorkBook,
          worksheet as import("xlsx").WorkSheet,
          name,
        ),
    },
    writeFile: (workbook, filename) =>
      xlsx.writeFile(workbook as import("xlsx").WorkBook, filename),
  };
}

export function writeStatsWorkbook(
  library: WorkbookLibrary,
  rows: StatsWorkbookRows,
  filename: string,
): void {
  const workbook = library.utils.book_new();
  library.utils.book_append_sheet(
    workbook,
    library.utils.json_to_sheet(rows.currentGame),
    "Current Game",
  );
  library.utils.book_append_sheet(
    workbook,
    library.utils.json_to_sheet(rows.gameLog),
    "Game Log",
  );
  library.utils.book_append_sheet(
    workbook,
    library.utils.json_to_sheet(rows.regularSeasonTotals),
    "Regular Season",
  );
  library.utils.book_append_sheet(
    workbook,
    library.utils.json_to_sheet(rows.playoffTotals),
    "Playoffs",
  );
  library.writeFile(workbook, filename);
}
